import "./ExcalidrawLogo.scss";

const LogoIcon = () => (
  <img
    src="/logo-drawmind-icon.png"
    alt="DrawMind"
    className="ExcalidrawLogo-icon"
  />
);

const LogoFull = () => (
  <img
    src="/logo-drawmind.png"
    alt="DrawMind"
    className="ExcalidrawLogo-full"
  />
);

type LogoSize = "xs" | "small" | "normal" | "large" | "custom" | "mobile";

interface LogoProps {
  size?: LogoSize;
  withText?: boolean;
  style?: React.CSSProperties;
  /**
   * If true, the logo will not be wrapped in a Link component.
   * The link prop will be ignored as well.
   * It will merely be a plain div.
   */
  isNotLink?: boolean;
}

export const ExcalidrawLogo = ({
  style,
  size = "small",
  withText,
}: LogoProps) => {
  return (
    <div
      className={`ExcalidrawLogo is-${size} ${
        withText ? "has-full-logo" : ""
      }`}
      style={style}
    >
      {withText ? <LogoFull /> : <LogoIcon />}
    </div>
  );
};
